export default __webpack_public_path__ + "static/media/faceA-victory.8e49ed80.png";